import React, { useEffect, useState } from 'react';
import { Option, Question } from './quiztypes';
import BizOption from './option';
import ProgressBar from './progress';

interface QuestionProps {
	question: Question;
	maxTimeInSec: number;
	onQuestionAnswered: (option: Option, elapsedTimeMS: number) => void;
	onTimesUp: () => void;
}

interface QuestionStatus {
	StartTimeMS: number;
	IsAnswered: boolean;
}

const BizQuestion = ({ question, maxTimeInSec, onQuestionAnswered, onTimesUp }: QuestionProps) => {
	const [qStatus, setQStatus] = useState<QuestionStatus>({
		StartTimeMS: 0,
		IsAnswered: false,
	});

	useEffect(() => {
		InitQuestion();

		return () => {
			cleanUp();
		};
	}, [question]);

	const cleanUp = () => {
		console.log('QUESTION CLEANUP');
	};

	const InitQuestion = () => {
		const startTimeMS = new Date().getTime();

		setQStatus({
			StartTimeMS: startTimeMS,
			IsAnswered: false,
		});
	};

	const questionAnsweredHandler = (option: Option) => {
		if (qStatus.IsAnswered) return;

		setQStatus({
			...qStatus,
			IsAnswered: true,
		});

		const elapsedTimeMS = new Date().getTime() - qStatus.StartTimeMS;
		onQuestionAnswered(option, elapsedTimeMS);
	};

	return (
		<div className={qStatus?.IsAnswered ? 'question-container is-answered' : 'question-container'}>
			<div className='question'>
				<h4>{question.Text}</h4>
			</div>
			<ProgressBar
				key={question.Id}
				timeInSeconds={maxTimeInSec}
				objectId={question.Id}
				stop={qStatus.IsAnswered}
				onTimesUp={onTimesUp}
			></ProgressBar>
			<div className='options-container'>
				{question.Options.map((option) => (
					<BizOption
						option={option}
						onClick={questionAnsweredHandler}
						isAnswered={qStatus.IsAnswered}
						key={option.Id}
					></BizOption>
				))}
			</div>
		</div>
	);
};

export default BizQuestion;
